import { render, staticRenderFns } from "./InformationPageAttributes.vue?vue&type=template&id=688ffe55&scoped=true&"
import script from "./InformationPageAttributes.vue?vue&type=script&lang=js&"
export * from "./InformationPageAttributes.vue?vue&type=script&lang=js&"
import style0 from "./InformationPageAttributes.vue?vue&type=style&index=0&id=688ffe55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688ffe55",
  null
  
)

export default component.exports